const components = [
    {comp: 'PatientProfile', name: 'Patient Profile'},
    {comp: 'ChiefComplaint', name: 'Chief Complaint'},
    {comp: 'HistoryPresentIllness', name: 'History of Present Illness'},
    {comp: 'PertinentPastMedicalHistory', name: 'Pertinent Past Medical History'},
    {comp: 'OBGyneHistory', name: 'OB-Gyne History'},
    {comp: 'PertinentSignSymptoms', name: 'Pertinent Signs & Symptoms on Admission'},
    {comp: 'ReferredHCI', name: 'Referred from another health care institution(HCI)'},
    {comp: 'PhysicalExamination', name: 'Physical Examination on Admission'},
    {comp: 'CourseWard', name: 'Course in the Ward'},
    {comp: 'OutcomeTreatment', name: 'Outcome of Treatment'},
    {comp: 'ProfessionalCertification', name: 'Certification of Health Care Professional'},
    {comp: 'Medicine', name: 'Medicine'},
];
export default components;